import { combineReducers } from '@reduxjs/toolkit';
import entities from './entities';
import { apiSlice } from "src/_api/apiSlice"

export default combineReducers({
    entities,
    [apiSlice.reducerPath]: apiSlice.reducer
});